import { useFormContext } from "react-hook-form";
import { type CardActivationFormData } from "@/features/card/schemas/forms/cardActivationForm.schema";
import { ControlledOTPInput } from "@/shared/components/forms/ControlledOTPInput";

export const CardActivationSlideContent = () => {
  const { control } = useFormContext<CardActivationFormData>();

  return (
    <ControlledOTPInput<CardActivationFormData>
      id="card-activation-code-input"
      label="Saisissez les 9 chiffres au dos de la carte"
      name="public_token"
      control={control}
      length={9}
      groupLength={3}
      autoFocus
    />
  );
};
